import { useDigitalTrapsStore } from '@features/regional-overview/digital-traps/digital-traps.zustand';
import { useGetDigitalTrapsPredictions } from 'querys/regional-overview/regional-overview.query';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useFlightCurveStore } from '../../flight-curve.zustand';
import { ALL_TRAPS_SELECTED_VALUE } from '../../sidebar/sidebar.model';

export const useGraphFlightStage = () => {
  const { companyId } = useParams();
  const { selectedTraps, selectedNetwork } = useFlightCurveStore();
  const trapGroups = useDigitalTrapsStore(state => state.trapGroups);

  const realAssetIds = useMemo(() => {
    const network = trapGroups.find(group => group.id === selectedNetwork?.id);

    if (!network) return [];

    if (selectedTraps[0] === ALL_TRAPS_SELECTED_VALUE) {
      return network.trapsInGroup.map(trap => trap.properties.asset_id);
    } else {
      return network.trapsInGroup.filter(trap => selectedTraps.includes(trap.properties.id)).map(trap => trap.properties.asset_id);
    }
  }, [selectedTraps, selectedNetwork, trapGroups]);

  const hasLegend = useMemo(() => {
    if (selectedTraps[0] === ALL_TRAPS_SELECTED_VALUE) return false;
    return true;
  }, [selectedTraps]);

  const { data: predictions, isLoading: isPredictionsLoading } = useGetDigitalTrapsPredictions(companyId ?? '', realAssetIds);

  return {
    predictions,
    isPredictionsLoading,
    hasLegend,
    realAssetIds
  };
};
